<template>
  <!-- 周期分类 -->
  <a-layout-content>
    <div v-if="role41">
      <a-button type="primary" @click="add()">添加分类</a-button>
      <span class="red">计算奖励过程中，将按照排序字段从小到大的顺序依次进行计算，排序字段不能重复！！！</span>
    </div>
    <br />
    <a-table
      size="middle"
      :columns="columns"
      row-key="ID"
      :data-source="data"
      :pagination="false"
      :scroll="{ y: 500 }"
      bordered
    >
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" @click="edit(record)" v-if="role41">
          <a-icon type="edit" style="font-size: 22px"></a-icon>
        </a>
        &nbsp;
        <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)" v-if="role42">
          <a href="javascript:;">
            <a-icon type="delete" style="font-size: 22px"></a-icon>
          </a>
        </a-popconfirm>
      </template>
    </a-table>

    <!-- 对话框 ------------------------------------->
    <a-modal
      v-model="visible"
      :title="modaltype === 0 ? '新增分类' : '编辑分类'"
      @ok="handleOk"
    >
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="分类名称"  ref="Tname" prop="Tname">
          <a-input v-model="form.Tname" placeholder="分类名称" />
        </a-form-model-item>
        <a-form-model-item label="排序字段" ref="Index" prop="Index">
          <a-input v-model.number="form.Index" placeholder="请不要重复,计算奖励将会按照这个字段从小到大依次开始计算" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
import { isNumber } from "../../js/textverify";

export default {
  data() {
    return {
      /*** 权限
        40	会员等级新增/编辑
        41	会员等级查询
        42	会员等级删除
       */
      role40:false,
      role41:false,
      role42:false,
      visible: false,
      modaltype: 0,
      data: [],
      columns: [
        {
          title: "编号",
          dataIndex: "ID",
          align: "center",
          width: "10%",
        },
        {
          title: "分类名称",
          dataIndex: "Tname",
          align: "center",
          width: "40%",
        },
        {
          title: "排序字段",
          dataIndex: "Index",
          align: "center",
          width: "20%",
        },
        {
          title: "操作",
          dataIndex: "operation",
          align: "center",
          width: "30%",
          scopedSlots: { customRender: "operation" },
        },
      ],
      form: {},
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      rules:{
        Index: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { validator: isNumber, trigger: 'change' },
        ],
        Tname: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },        
        ],
      }
    };
  },
  methods: {
    onDelete(val) {
     const that = this;
      this.$confirm({
        title: "删除期别",
        content: "警告是否要删除该期别,当删除该期别后会员投注的相关期别将一并清除!!,提示:如选择删除后可前往会员统计重新统计功能",
        onOk() {
           that.axios.post("/rank/deletetermset", {id:val.ID}).then((res) => {
             if (res.data) {
               that.$message.success("删除成功");
               that.qryListAPI();
             }
           });
        },
      });

    },
    add() {
      this.modaltype = 0;
      this.form = {};
      this.form.ID = 0;
      this.form.Type = 2;
      this.visible = true;
    },
    edit(val) {
      this.modaltype = 1;
      this.form = val;
      this.visible = true;
    },
    //对话框确认按钮
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.axios.post("/rank/settermset", this.form).then((res) => {
            if(res.data){
              const mes = this.modaltype === 0 ? "添加成功" : "编辑成功";
              this.$message.success(mes);
              this.qryListAPI();
            }
          });
        } 
      });
    },
    // 查询API
    qryListAPI() {
      this.axios.post("/rank/gettermset", {Type:2}).then((res) => {
        if (res.data) {
          this.data = res.data;
        }
      });
    },
  },
  //首次加载
  created() {
    this.qryListAPI();
    //获取权限
    const array = JSON.parse(sessionStorage.RoleID);
    const roleID = [40,41,42];
    var isRole = roleID.filter(function(item){
      return array.indexOf(item) != -1
    });
    //功能权限获取
    isRole.forEach(element => {
      this["role" + element] = true;
    });
  },
};
</script>

<style>
.red {
  color: rgb(255, 0, 0);
}
</style>


// WEBPACK FOOTER //
// src/components/liveleaderboard/termset.vue